import { NavLink } from 'react-router-dom'
import { twMerge } from 'tailwind-merge'

interface HeaderItemProps {
  children: React.ReactNode
  path: string
  onClick: () => void
  isActive: boolean
}

export function HeaderItem({
  path,
  onClick,
  isActive,
  children,
}: HeaderItemProps) {
  return (
    <NavLink
      to={path}
      className={twMerge(
        'flex w-fit items-center justify-center gap-4 whitespace-nowrap rounded-md border-transparent px-4 py-[9px] font-outfit text-base leading-5 text-opacity-85 transition-colors delay-75 hover:text-white md:px-3',
        isActive
          ? 'bg-white/10 text-white'
          : 'cursor-pointer bg-transparent text-gray-400',
      )}
      onClick={onClick}>
      {children}
    </NavLink>
  )
}
